import api from "./axios";

export const getSettingsApi = () => api.get("/settings");

export const updateCallPolicyApi = (data) =>
  api.put("/settings/call-policy", data);

export const updateGradeStatusApi = (data) =>
  api.put("/settings/grade-status", data);

export const updatePipelineStatusApi = (data) =>
  api.put("/settings/pipeline-status", data);

export const updateLeadFeaturesApi = (data) =>
  api.put("/settings/lead-features", data);

export const updatePipelineFeaturesApi = (data) =>
  api.put("/settings/pipeline-features", data);

export const updateServicesApi = (services) =>
  api.put("/settings/services", { services });

export const updateAiConfigApi = (data) =>
  api.put("/settings/ai-config", data);
